import React, { useEffect, useState, useContext } from 'react';
import { Menu, MenuItem, Typography } from '@material-ui/core';
import dashboardStyles from '../Dashboard.style';
import { useSelector } from 'react-redux';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {
	PROJECTS,
	BASIC,
	RUN_NOW,
	RUN_AGAIN,
	RUNNING,
	SCHEDULED,
	NOW,
	LATER,
	COMPLETED,
	FAILED
} from 'constants/constant';
import { UserPortalContext } from 'context/appcontext';
import moment from 'moment';
import { FEATURES } from 'helper/basicFeatureFlag';

function MoreOptions(props) {
	const { open, setOpen, handleRunNow, data } = props;
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);
	const reportsList = useSelector((state) =>
		tabValue === PROJECTS ? state.dashboardReducer.reportsList : state.dashboardReducer.sharedList
	);
	const [anchorEl, setAnchorEl] = useState(null);
	const classes = dashboardStyles();
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const { DISABLE_CONTEXT_RUN_NOW: disableRunNow } = FEATURES[customerType].DASHBOARD;

	const handleClose = (event) => {
		stopPropagation(event);
		setAnchorEl(null);
		setOpen(null);
	};

	const stopPropagation = (event) => {
		event?.stopPropagation();
	};

	const handleOpen = () => {
		setAnchorEl(open);
	};

	useEffect(() => {
		checkStatus();
		if (open) {
			handleOpen();
		}
	}, [open]);

	const checkStatus = () => {
		let result = false;
		reportsList.filter((item) => {
			if (item.status === RUNNING && item.reportId === data.reportId) {
				result = true;
			}
		});

		return result;
	};

	const checkRunNow = (rowData) => {
		if (moment(rowData?.scheduleEndDate).isBefore(moment())) {
			return true;
		}
		if (rowData?.status === RUNNING) {
			return true;
		}
		if (rowData?.status === COMPLETED && [NOW, LATER].includes(rowData?.frequency)) {
			return true;
		}
		if (rowData?.status === SCHEDULED && rowData?.frequency === NOW) {
			return true;
		}
		if (disableRunNow) {
			// For Basic users
			// 'Run Now' should only be available on Failed reports and not for other status
			let runNowDisabled = true;
			if (rowData?.status === FAILED) {
				runNowDisabled = false;
			}
			return runNowDisabled;
		}
		return false;
	};

	const runNowEnabled = checkRunNow(data);

	return (
		<Menu
			id={`More-items`}
			anchorEl={anchorEl}
			elevation={1}
			style={{ marginTop: 56 }}
			PaperProps={{
				style: {
					width: 168
				}
			}}
			MenuListProps={{
				'aria-labelledby': 'basic-button'
			}}
			open={Boolean(anchorEl)}
			onClose={handleClose}>
			<MenuItem
				key="run-now"
				id="run-now"
				disabled={checkStatus() || runNowEnabled}
				className={classes.menuItems}
				onClick={(e) => {
					handleRunNow();
					e.stopPropagation();
					setAnchorEl(null);
					setOpen(null);
				}}>
				<Typography style={{ display: 'flex', alignItems: 'center' }}>
					<PlayArrowIcon fontSize="medium" style={{ marginRight: 16 }} />
					{customerType === BASIC && !runNowEnabled ? RUN_AGAIN : RUN_NOW}
				</Typography>
			</MenuItem>
		</Menu>
	);
}

MoreOptions.propTypes = {};

export default MoreOptions;
